import { watchAddDpNewsFeedTag } from './addDpNewsFeedTag';
import { watchCheckDpPostAccess } from './checkDpPostAccess';
import { watchDeleteDpNewsFeedAccess } from './deleteDpNewsFeedAccess';
import { watchFetchDpNewsFeedPost } from './fetchDpNewsFeedPost';
import { watchFetchDpNewsFeedPosts } from './fetchDpNewsFeedPosts';
import { watchUpdateDpNewsFeedPost } from './updateDpNewsFeedPost';

export const dpNewsFeedSagas = [
  watchAddDpNewsFeedTag(),
  watchCheckDpPostAccess(),
  watchDeleteDpNewsFeedAccess(),
  watchFetchDpNewsFeedPost(),
  watchFetchDpNewsFeedPosts(),
  watchUpdateDpNewsFeedPost()
];
